import React from 'react';
import {Field, reduxForm} from 'redux-form';
import MenuItem from 'material-ui/MenuItem';
import style from '../../../styles/styles'
import RaisedButton from 'material-ui/RaisedButton';
import PropTypes from 'prop-types';
import {renderPasswordField, renderSelectField, renderTextField} from "../../../services/form";
import withTranslation from "../../../hoc/withTranslation";
import i18n from 'i18next';

const validate = (values) => {
    const errors = {};
    const requiredFields = [
        'application_id',
        'email',
        'username',
        'role'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });

    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = i18n.t('generic.error_invalid_email');
    }

    if ((values.password || values.repeat) && values.password !== values.repeat) {
        errors.password = i18n.t('generic.error_password_should_be_identical')
        errors.repeat = errors.password;
    }

    return errors;
};

export const AddAdminForm = (props) => {
    const {apps, handleSubmit, pristine, reset, submitting} = props;
    let appsMenuItems = apps.map(function (app, index) {
        return (<MenuItem key={app.id} value={app.id} primaryText={app.name}/>);
    });

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <Field id="application_id" name="application_id" component={renderSelectField} label={props.t('generic.application')}>
                    {appsMenuItems}
                </Field>
                <Field id="email" name="email" component={renderTextField} label={props.t('user.email')} fullWidth={true}/>
                <Field id="username" name="username" component={renderTextField} label={props.t('user.username')} fullWidth={true}/>
                <Field id="firstname" name="firstname" component={renderTextField} label={props.t('user.firstname')} fullWidth={true}/>
                <Field id="lastname" name="lastname" component={renderTextField} label={props.t('user.lastname')} fullWidth={true}/>
                <Field id="password" name="password" component={renderPasswordField} label={props.t('account_page.password_optional')} fullWidth={true}/>
                <Field id="repeat" name="repeat" component={renderPasswordField} label={props.t('account_page.repeat_password_optional')} fullWidth={true}/>
                <Field id="role" name="role" component={renderSelectField} label={props.t('generic.role')}>
                    <MenuItem key="ROLE_MARKETING" value="ROLE_MARKETING" primaryText={props.t('role.marketing')}/>
                    <MenuItem key="ROLE_ADMIN" value="ROLE_ADMIN" primaryText={props.t('role.admin')}/>
                    <MenuItem key="ROLE_SUPER_ADMIN" value="ROLE_SUPER_ADMIN" primaryText={props.t('role.super_admin')}/>
                </Field>
            </div>
            <div style={style.formButtons}>
                <RaisedButton
                    style={style.formButton}
                    id="submit"
                    label={props.t('generic.save')}
                    disabled={pristine || submitting}
                    type="submit"
                    primary={true}
                />
                <RaisedButton
                    style={style.formButton}
                    label={props.t('generic.reset')}
                    type="button"
                    disabled={pristine || submitting}
                    onClick={reset}
                />
            </div>
        </form>
    );
};

AddAdminForm.propTypes = {
    apps: PropTypes.arrayOf(PropTypes.object)
};

export default reduxForm({
    form: 'editAdmin',
    validate
})(withTranslation(AddAdminForm));



// WEBPACK FOOTER //
// src/components/admin/AddAdminForm/AddAdminForm.js